module.exports = __webpack_public_path__ + "static/img/mobkast-logo-icon.1e49a96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobkast-logo-icon.png
// module id = 8F2D
// module chunks = 0